module.exports = __webpack_public_path__ + "static/media/5DPO2.17fc3cd9.jpg";